/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ConfigInfoImage
 */
export interface ConfigInfoImage {
  /**
   * Used by frontend to lookup which image to use.
   * The naming and usage is left to the specific application.
   * @type {string}
   * @memberof ConfigInfoImage
   */
  referenceKey: string
  /**
   *
   * @type {string}
   * @memberof ConfigInfoImage
   */
  url: string
}

/**
 * Check if a given object implements the ConfigInfoImage interface.
 */
export function instanceOfConfigInfoImage(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'referenceKey' in value
  isInstance = isInstance && 'url' in value

  return isInstance
}

export function ConfigInfoImageFromJSON(json: any): ConfigInfoImage {
  return ConfigInfoImageFromJSONTyped(json, false)
}

export function ConfigInfoImageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConfigInfoImage {
  if (json === undefined || json === null) {
    return json
  }
  return {
    referenceKey: json['ReferenceKey'],
    url: json['Url'],
  }
}

export function ConfigInfoImageToJSON(value?: ConfigInfoImage | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    ReferenceKey: value.referenceKey,
    Url: value.url,
  }
}
